module.exports = __webpack_public_path__ + "static/img/s-chenyu.cbde1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s-chenyu.png
// module id = zKBV
// module chunks = 1